import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";

import { MedIconPhoneForwardedComponent } from "./med-icon-phone-forwarded.component";

@NgModule({
  declarations: [
    MedIconPhoneForwardedComponent,
  ],
  imports: [
    CommonModule,
  ],
  exports: [
    MedIconPhoneForwardedComponent,
  ],
})
export class MedIconPhoneForwardedModule { }
